import React from "react";
import ReactDOM from "react-dom/client";
import App from "./App";
import RemoteBooksGate from "./RemoteBooksGate";
import SiteBadge from "./components/SiteBadge";
import { remoteConfigFromEnv } from "./utils/remoteStorage";
import { disableBrowserAutocomplete } from "./utils/noBrowserAutocomplete";
import "./styles.css";

// Multi-device sync: a build with Supabase settings (Cloudflare sets them per site) opens on
// the shared online books; any other build (npm start, tests) keeps using localStorage.
const remoteConfig = remoteConfigFromEnv();

// No browser "typed before" dropdown on any field (utils/noBrowserAutocomplete.js).
disableBrowserAutocomplete();

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    {remoteConfig ? <RemoteBooksGate config={remoteConfig} /> : <App />}
    <SiteBadge label={process.env.REACT_APP_SITE_LABEL} />
  </React.StrictMode>
);
